module.exports = __webpack_public_path__ + "static/media/ds-8-powermatic_01.55d25f3c.png";